import styled from 'styled-components'

const SearchContainer = styled.div`
  margin: 8px 12px;
`

const SectionWrap = styled.div`
  overflow-y: auto;
  height: calc(100% - 180px);
`

const FilterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 12px 20px;
`

const FilterLabel = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  color: rgba(136, 136, 136, 1);
  white-space: nowrap;
`

const FilterSelectWrapper = styled.div`
  width: 150px;
  flex-shrink: 0;
`

const RadioCircle = styled.span<{ isSelected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${({ isSelected }) => (isSelected ? 'var(--color-button-primary)' : 'var(--color-ghost-grey)')};
  margin-right: 10px;
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ isSelected }) => (isSelected ? 'var(--color-button-primary)' : 'transparent')};
  }
`

export { SearchContainer, SectionWrap, FilterRow, FilterLabel, FilterSelectWrapper, RadioCircle }
